// Public menu theme presets. Each preset defines a real, distinct color combination.
export const THEMES = {
  "oro-nero": {
    name: "Oro & Nero", desc: "Elegante, fine dining", dark: true,
    bg: "#0B0B0C", surface: "#161616", text: "#F5F1E6", muted: "#A79D86",
    accent: "#B2A475", accentLight: "#C7B78F",
    heading: "'Cormorant Garamond', serif", body: "'Manrope', sans-serif",
    swatch: ["#0B0B0C", "#B2A475"],
  },
  "bianco-blu": {
    name: "Bianco & Blu", desc: "Pulito e moderno", dark: false,
    bg: "#FFFFFF", surface: "#F1F5FF", text: "#0F2A5B", muted: "#5B6B8C",
    accent: "#1E56D6", accentLight: "#4C7DF0",
    heading: "'Playfair Display', serif", body: "'Manrope', sans-serif",
    swatch: ["#FFFFFF", "#1E56D6"],
  },
  "verde-lime": {
    name: "Verde & Lime", desc: "Fresco e contemporaneo", dark: true,
    bg: "#0C1A10", surface: "#152A1B", text: "#EAF6EC", muted: "#8FB49A",
    accent: "#A3E635", accentLight: "#C6F26B",
    heading: "'Cormorant Garamond', serif", body: "'DM Sans', sans-serif",
    swatch: ["#0C1A10", "#A3E635"],
  },
  "blu-azzurro": {
    name: "Blu scuro & Azzurro", desc: "Marino, sofisticato", dark: true,
    bg: "#0A1A2F", surface: "#122744", text: "#EAF2FB", muted: "#8AA6C6",
    accent: "#38BDF8", accentLight: "#7DD3FC",
    heading: "'Playfair Display', serif", body: "'Manrope', sans-serif",
    swatch: ["#0A1A2F", "#38BDF8"],
  },
  "corten-oro": {
    name: "Corten & Oro", desc: "Rustico elegante", dark: true,
    bg: "#241109", surface: "#3A1D10", text: "#F6E9DD", muted: "#C29B82",
    accent: "#B2A475", accentLight: "#D0C08A",
    heading: "'Cormorant Garamond', serif", body: "'Manrope', sans-serif",
    swatch: ["#8A3B1E", "#B2A475"],
  },
  "bordeaux-crema": {
    name: "Bordeaux & Crema", desc: "Caldo, mediterraneo", dark: true,
    bg: "#4A1220", surface: "#5E1A2B", text: "#F7F0E4", muted: "#C9A9A9",
    accent: "#F0E6D2", accentLight: "#F7F0E4",
    heading: "'Cormorant Garamond', serif", body: "'Manrope', sans-serif",
    swatch: ["#4A1220", "#F0E6D2"],
  },
  "viola-ororosa": {
    name: "Viola Scuro & Oro Rosa", desc: "Trendy, aperitivo", dark: true,
    bg: "#2E1A47", surface: "#3D2560", text: "#F2E9F5", muted: "#A98FC0",
    accent: "#B76E79", accentLight: "#CE8C96",
    heading: "'Playfair Display', serif", body: "'DM Sans', sans-serif",
    swatch: ["#2E1A47", "#B76E79"],
  },
  "antracite-argento": {
    name: "Grigio Antracite & Argento", desc: "Minimal, moderno", dark: true,
    bg: "#2B2B2E", surface: "#3A3A3E", text: "#F0F0F2", muted: "#9A9A9E",
    accent: "#C0C0C0", accentLight: "#D8D8D8",
    heading: "'Manrope', sans-serif", body: "'DM Sans', sans-serif",
    swatch: ["#2B2B2E", "#C0C0C0"],
  },
  "verde-bosco-oro": {
    name: "Verde Bosco & Oro", desc: "Naturale, lussuoso", dark: true,
    bg: "#1B3B2F", surface: "#264F40", text: "#EAF3ED", muted: "#8FB0A0",
    accent: "#B2A475", accentLight: "#D0C08A",
    heading: "'Cormorant Garamond', serif", body: "'Manrope', sans-serif",
    swatch: ["#1B3B2F", "#B2A475"],
  },
};

// Backward-compat aliases for restaurants saved with the old ids.
const ALIAS = { "theme-1": "oro-nero", "theme-2": "bianco-blu", "theme-3": "verde-lime" };
export const DEFAULT_THEME = "oro-nero";

export const getTheme = (settings) => {
  const raw = settings?.theme_id;
  const id = ALIAS[raw] || raw || DEFAULT_THEME;
  const base = { ...(THEMES[id] || THEMES[DEFAULT_THEME]) };
  return { ...base, ...(settings?.colors || {}) };
};

export const THEME_PRESETS = Object.entries(THEMES).map(([id, t]) => ({
  id, name: t.name, desc: t.desc, swatch: t.swatch,
}));
